import { FooterLinkCategory } from '@ebeihilfe/core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toI18nKey',
  standalone: true,
})
export class ToI18nKeyPipe implements PipeTransform {
  public transform(value: FooterLinkCategory): string {
    switch (value) {
      case 'ABOUT':
        return 'text.simpleAbout';
      case 'LINKS':
        return 'label.links';
      case 'STORE_ENTRYS':
        return 'footer.text.app_in_stores';
    }
  }
}
